import {
  USER_FRUI_QPPZ_MODAL_CHANGE,
} from './constants';

export function frui_qppzModalChange(visible,type) {
  return {
    type: USER_FRUI_QPPZ_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_FRUI_QPPZ_MODAL_CHANGE:
      return {
        ...state,
        frui_qppzModalType:action.data.type,
        frui_qppzModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/frui_qppzModalChange.js